const LocalStorageItems = Object.freeze({
    STUDIESDATASORT: 'studiesDataSort',
    APPLICATIONGRIDSORT: 'ApplicationGrid.sort',
    UNAUTHENTICATEDROUTELANGUAGE: 'i18n.unauthenticatedRouteLanguage',
    RECENTACTIVITYGRIDSORT: 'RecentActivityGrid.sort',
    LOGINDETAILGRIDSORT: 'LoginDetailsGrid.sort',
});

export default LocalStorageItems;
